import template from './report_employment_equity.html';
import * as Utils from '../../lib/savanna_utils.js';
import tr from '../../lib/default-translator.js';

class ReportEmploymentEquityViewModel
{
	constructor (page)
	{
		this.page = page;
		this.loader = ko.observable(false);

		this.mv_exists = ko.observable(false);  
		this.current_department_id = ko.observable(-1);
		this.current_company_id = ko.observable(-1);
		this.selected_company = ko.observable();
		this.selected_department = ko.observable();

		this.selected_from_date = ko.observable(moment().subtract(1, 'years').format('YYYY-MM-DD'));
		this.selected_to_date = ko.observable(moment().format('YYYY-MM-DD'));

		this.selected_company.subscribe((newValue) => {
			if (newValue != null)
			{
				this.current_company_id(newValue.company_id);
				this.page.updateData();
			}
			else
			{
				this.current_company_id(-1);
				this.page.updateData();
			}
		});

		this.selected_department.subscribe((newValue) => {
			if (newValue != null)
			{
				this.current_department_id(newValue.department_id);
				this.page.updateData();
			}
			else
			{
				this.current_department_id(-1);
				this.page.updateData();
			}
		});

		this.selected_from_date.subscribe((newValue) => {
			if (this.selected_from_date() && this.selected_to_date())
				if (this.selected_from_date() <= this.selected_to_date())
					this.page.updateData();
				else
					this.selected_to_date(newValue);
		});

		this.selected_to_date.subscribe((newValue) => {
			if (this.selected_from_date() && this.selected_to_date())
				if (this.selected_from_date() <= this.selected_to_date())
					this.page.updateData();
				else
					this.selected_from_date(newValue);
		});
	}

	async download_clicked()
	{
		window.location.href = '/download/eea_report/' + this.current_company_id() + '/' + this.current_department_id() +  '/' + this.selected_from_date() + '/' + this.selected_to_date();
	}

	async download_view_clicked()
	{
		window.location.href = '/download/eea_report_view/' + this.current_company_id() + '/' + this.current_department_id() +  '/' + this.selected_from_date() ;
	}
}

class ReportEmploymentEquityPage
{
	constructor (bindings)
	{
		this.bindings = bindings;
		this.viewModel = new ReportEmploymentEquityViewModel(this);
		let tr = Utils.get_translator('default');
		window.current_page_title(tr('EEA Reports'));
	}

	async init()
	{
		// check access to page
		if (await Utils.redirectOnAccessDenied('ViewEEAReport'))
			return;

		document.title = tr('EEA reports');
		await this.refresh_report(); 
	}

	async updateData()
	{
		let res = await Grape.fetches.getJSON('/reports/check_mv_employee_info_eea_report_exists', {});
		if (res) 
		{ 
			if (res.status == 'success') 

				this.viewModel.mv_exists(res.exists); 
		}
	}

	show_report_help()
	{
		Grape.dialog.open('EEAReportHelp', { 'employee_id': this.bindings.id }, {});
	}

	async refresh_report(show_alert = false)  // Only show alert on manual refresh
	{
	    this.viewModel.loader(true);
	
	    let res = await Grape.fetches.postJSON('/reports/refresh_mv_employee_info_eea_report', {});
	
	    if (res)
	    {
	        this.viewModel.loader(false);
	        if (res.status == 'success')
	        {
	            if (show_alert)  // ← only alert when user clicks the button
	                Grape.alerts.alert({type: 'success', title: 'Success', message: res.message});
	            await this.updateData();
	        }
	        else 
	        {
	            let response = await Grape.alerts.confirm({
	                type: 'warning', 
	                title: tr('Error while creating view'),
	                message: tr('The view could not be created. Do you want to automatically create the necessary employee fields for the view?'),
	                accept_text: tr('Yes'), 
	                cancel_text: tr('No')
	            });
			
	            if (response)
	            {
	                this.viewModel.loader(true);
	                let create_fields = await this.create_employee_fields();
	                if (create_fields)
	                    this.refresh_report(true);  // ← show alert after manual recovery
	                else
	                    Grape.alerts.alert({type: "error", title: "Error", message: tr('Something went wrong. Please contact the Yooma HR team for assistance')});
	                    this.viewModel.loader(false);
	            }
	        }
	    }
	}

	async create_employee_fields()
	{
		let res = await Grape.fetches.postJSON('/reports/create_fields_for_eea_report', {});
		if (res) 
		{
			if (res.status == 'success')
				return true; 
			else 
				return false; 
		}
	}
}

export default {
	route: '[/]report/report_employment_equity',
	page_class: ReportEmploymentEquityPage,
	template: template,
	template_filename: 'translation/report_employment_equity'
};
